function assertPluginsInitialized(pluginSystemRunner) {
  if (pluginSystemRunner == void 0) {
    throw new Error("Plugins have not been initialized. Run `PrismicManager.plugins.prototype.initPlugins()` before re-calling this method.");
  }
}
export {
  assertPluginsInitialized
};
//# sourceMappingURL=assertPluginsInitialized.js.map
